import { z } from 'zod';

/**
 * Canonical locale contract used across shared schemas.
 * Keep this file as the single source of truth to avoid drift.
 */
export const LocaleSchema = z.enum(['de-DE', 'en-US', 'fr-CH']);
export type Locale = z.infer<typeof LocaleSchema>;

export const DEFAULT_LOCALE: Locale = 'de-DE';
